import React from 'react';

const CloseIcon = ({className}) => (
  <svg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.28316 1.92973L1.99023 1.22266L14.718 13.9504L14.0109 14.6575L1.28316 1.92973Z" fill="white" stroke="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M1.99029 14.6563L1.2832 13.9492L14.011 1.22144L14.7181 1.92853L1.99029 14.6563Z" fill="white" stroke="white"/>
  </svg>

);

export default CloseIcon;
